import { useCallback, useRef, useEffect, useState } from 'react';
import { List } from 'immutable';

const useAgGridPaymentsPreviewNavigation = ({ gridApiRef, isGridReady, list = List() }) => {
  const [state, setState] = useState({ id: null });
  const [startIndex, setStartIndex] = useState(0);
  const previewNavigateDirectionRef = useRef(null);

  const isPreviewOpen = Boolean(state.id);

  useEffect(() => {
    if (state.id && isGridReady && gridApiRef?.current) {
      const size = gridApiRef.current.paginationGetPageSize() || 0;
      const pageIndex = gridApiRef.current.paginationGetCurrentPage() || 0;
      setStartIndex(size * pageIndex);
    }
  }, [state.id, isGridReady, gridApiRef]);

  const handleChangePreview = useCallback((id) => {
    setState({ id });
  }, []);

  const handlePreviewNavigate = useCallback(
    (direction) => {
      if (isGridReady && gridApiRef?.current) {
        const pageIndex = gridApiRef.current.paginationGetCurrentPage();
        const newPageIndex = pageIndex + direction;
        previewNavigateDirectionRef.current = direction;
        gridApiRef.current.paginationGoToPage(newPageIndex);
      }
    },
    [gridApiRef, isGridReady],
  );

  useEffect(() => {
    if (isPreviewOpen && typeof previewNavigateDirectionRef.current === 'number') {
      const pageIndex = gridApiRef.current.paginationGetCurrentPage();
      const size = gridApiRef.current.paginationGetPageSize() || 0;

      if (previewNavigateDirectionRef.current > 0) {
        const previewDocument = list.first();
        handleChangePreview(previewDocument?.id);
      }

      if (previewNavigateDirectionRef.current < 0) {
        const previewDocument = list.last();
        handleChangePreview(previewDocument?.id);
      }

      previewNavigateDirectionRef.current = null;
      setStartIndex(size * pageIndex);
    }
  }, [list, isPreviewOpen, gridApiRef, handleChangePreview]);

  return {
    isPreviewOpen,
    handlePreviewNavigate,
    setPreviewState: setState,
    previewState: state,
    handleChangePreview,
    startIndex,
  };
};

export default useAgGridPaymentsPreviewNavigation;
